import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import './fonts/Inter/Inter-Bold.ttf'
import './fonts/Inter/Inter-Regular.ttf'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

